import React from 'react';
import ProductOverview from '../../product-overview/ProductOverview';
import product from '../all-gear.json';

const MenUAZipPullover = () => {
	return (
		<React.Fragment>
			<ProductOverview
				name={product.allGear[11].productName}
				color={product.allGear[11].color}
				size={product.allGear[11].sizes}
				price={product.allGear[11].price}
				img={product.allGear[11].img}
				miniImg1={product.allGear[11].miniImg1}
				miniImg2={product.allGear[11].miniImg2}
				miniImg3={product.allGear[11].miniImg3}
			/>
		</React.Fragment>
	);
};

export default MenUAZipPullover;
